import React from 'react';
import Icon from '../../components/AppIcon';
import { useNavigate } from 'react-router-dom';
import Button from '../../components/ui/Button';

const ContractOfferPage: React.FC = () => {
  const navigate = useNavigate();

  const handleGoBack = () => {
    navigate(-1);
  };

  const handleGoToPayment = () => {
    navigate('/payment-page');
  };

  return (
    <div className="min-h-screen bg-background">
      {/* Header */}
      <header className="bg-foreground text-background py-6 sticky top-0 z-50 shadow-lg">
        <div className="max-w-content mx-auto px-4 sm:px-6">
          <div className="flex items-center justify-between">
            <button
              onClick={handleGoBack}
              className="flex items-center gap-2 text-background/80 hover:text-background transition-colors"
            >
              <Icon name="ArrowLeft" size={20} />
              <span className="text-sm">Назад</span>
            </button>
            <h1 className="text-2xl font-bold">Договор-оферта</h1>
            <div className="w-20"></div> {/* Spacer for centering */}
          </div>
        </div>
      </header>

      {/* Main Content */}
      <main className="max-w-content mx-auto px-4 sm:px-6 py-12">
        <div className="bg-white rounded-2xl shadow-xl p-8 md:p-12">
          {/* Document Header */}
          <div className="text-center mb-8">
            <h2 className="text-3xl md:text-4xl font-bold text-foreground mb-4">
              ПУБЛИЧНАЯ ОФЕРТА
            </h2>
            <p className="text-lg text-foreground/70">
              на оказание информационно-аналитических услуг сервисом AIDATING.LOVE
            </p>
          </div>

          {/* Introduction */}
          <div className="mb-8 p-6 bg-primary/5 rounded-lg border border-primary/20">
            <p className="text-foreground/80 leading-relaxed">
              Настоящий документ является официальным предложением (офертой) децентрализованного сервиса AIDATING.LOVE (далее — «Исполнитель») к физическому лицу (далее — «Клиент»).
            </p>
          </div>

          {/* Section 1 */}
          <div className="mb-8">
            <h3 className="text-2xl font-bold text-foreground mb-4 flex items-center gap-3">
              <span className="w-8 h-8 bg-primary rounded-full flex items-center justify-center text-white text-sm font-bold">1</span>
              ПРЕДМЕТ СОГЛАШЕНИЯ
            </h3>
            <div className="space-y-4 ml-11">
              <div className="p-4 bg-gray-50 rounded-lg">
                <p className="text-foreground/80 mb-2">
                  <strong className="text-primary">1.1.</strong> Исполнитель обязуется оказать услуги по созданию цифрового психопрофиля (AI-аватара) Клиента и поиску совместимых партнеров, а Клиент обязуется оплатить эти услуги.
                </p>
              </div>
              <div className="p-4 bg-gray-50 rounded-lg">
                <p className="text-foreground/80 mb-3">
                  <strong className="text-primary">1.2.</strong> Услуги включают в себя:
                </p>
                <ul className="space-y-2 ml-6">
                  <li className="flex items-start gap-2 text-foreground/70">
                    <Icon name="Check" size={20} className="text-primary mt-0.5 flex-shrink-0" />
                    <span>Анализ аудио/видео интервью Клиента с использованием искусственного интеллекта.</span>
                  </li>
                  <li className="flex items-start gap-2 text-foreground/70">
                    <Icon name="Check" size={20} className="text-primary mt-0.5 flex-shrink-0" />
                    <span>Оцифровка личности и загрузка данных в закрытую базу.</span>
                  </li>
                  <li className="flex items-start gap-2 text-foreground/70">
                    <Icon name="Check" size={20} className="text-primary mt-0.5 flex-shrink-0" />
                    <span>Проведение виртуальных симуляций (свиданий) AI-аватара Клиента с другими профилями.</span>
                  </li>
                </ul>
              </div>
              <div className="p-4 bg-gray-50 rounded-lg">
                <p className="text-foreground/80">
                  <strong className="text-primary">1.3.</strong> Акцептом (полным принятием) данной оферты считается факт оплаты услуг Клиентом.
                </p>
              </div>
            </div>
          </div>

          {/* Section 2 */}
          <div className="mb-8">
            <h3 className="text-2xl font-bold text-foreground mb-4 flex items-center gap-3">
              <span className="w-8 h-8 bg-primary rounded-full flex items-center justify-center text-white text-sm font-bold">2</span>
              СТОИМОСТЬ И ПОРЯДОК ОПЛАТЫ (WEB3)
            </h3>
            <div className="space-y-4 ml-11">
              <div className="p-4 bg-gradient-to-r from-primary/10 to-primary/5 rounded-lg border border-primary/30">
                <p className="text-foreground/80 mb-2">
                  <strong className="text-primary">2.1. Мини-тест: 3 канала коммуникации (Lite):</strong>
                </p>
                <p className="text-lg font-semibold text-foreground">Бесплатно</p>
                <p className="text-foreground/70 text-sm mt-2">Включает базовую оценку 3 каналов коммуникации, короткое объяснение результатов.</p>
              </div>
              <div className="p-4 bg-gradient-to-r from-primary/10 to-primary/5 rounded-lg border border-primary/30">
                <p className="text-foreground/80 mb-2">
                  <strong className="text-primary">2.2. Полный тест: 7 каналов коммуникации (Pro):</strong>
                </p>
                <p className="text-lg font-semibold text-foreground">Единоразовый платеж — $5 (в крипто-эквиваленте).</p>
                <p className="text-foreground/70 text-sm mt-2">Включает полную диагностику всех 7 каналов коммуникации, профиль совместимости, индивидуальные рекомендации по общению.</p>
              </div>
              <div className="p-4 bg-gradient-to-r from-primary/10 to-primary/5 rounded-lg border border-primary/30">
                <p className="text-foreground/80 mb-2">
                  <strong className="text-primary">2.3. Digital Twin Lite (текстовая оцифровка):</strong>
                </p>
                <p className="text-lg font-semibold text-foreground">Единоразовый платеж — $15 (в крипто-эквиваленте).</p>
                <p className="text-foreground/70 text-sm mt-2">Включает подробный психопрофиль, создание цифрового двойника с базовой детализацией, размещение в симуляторе и подбор совпадений.</p>
              </div>
              <div className="p-4 bg-gradient-to-r from-primary/10 to-primary/5 rounded-lg border border-primary/30">
                <p className="text-foreground/80 mb-2">
                  <strong className="text-primary">2.4. Digital Twin Voice (текст + голос):</strong>
                </p>
                <p className="text-lg font-semibold text-foreground">Единоразовый платеж — $25 (в крипто-эквиваленте).</p>
                <p className="text-foreground/70 text-sm mt-2">Включает психопрофиль, голосовую детализацию личности, цифрового двойника с голосом в симуляторе, более точные совпадения и прогноз совместимости.</p>
              </div>
              <div className="p-4 bg-gradient-to-r from-primary/10 to-primary/5 rounded-lg border border-primary/30">
                <p className="text-foreground/80 mb-2">
                  <strong className="text-primary">2.5. Digital Twin Video (текст + голос + видео):</strong>
                </p>
                <p className="text-lg font-semibold text-foreground">Единоразовый платеж — $35 (в крипто-эквиваленте).</p>
                <p className="text-foreground/70 text-sm mt-2">Включает глубокий психопрофиль, голосовую детализацию, видео-анализ невербального поведения, цифрового двойника с голосом и внешностью в симуляторе, максимально точный подбор.</p>
              </div>
              <div className="p-4 bg-gray-50 rounded-lg">
                <p className="text-foreground/80 mb-3">
                  <strong className="text-primary">2.6. Порядок расчетов:</strong>
                </p>
                <ul className="space-y-3">
                  <li className="flex items-start gap-2 text-foreground/70">
                    <Icon name="Wallet" size={20} className="text-primary mt-0.5 flex-shrink-0" />
                    <span>Оплата производится в криптовалюте (USDT/USDC или иные согласованные активы).</span>
                  </li>
                  <li className="flex items-start gap-2 text-foreground/70">
                    <Icon name="Shield" size={20} className="text-primary mt-0.5 flex-shrink-0" />
                    <span>Стороны признают, что подтверждением оплаты является запись транзакции в публичном реестре блокчейна (Transaction Hash / TxID).</span>
                  </li>
                  <li className="flex items-start gap-2 text-foreground/70">
                    <Icon name="CheckCircle" size={20} className="text-primary mt-0.5 flex-shrink-0" />
                    <span>Данная цифровая запись имеет полную юридическую силу акта приемки-передачи средств.</span>
                  </li>
                  <li className="flex items-start gap-2 text-foreground/70">
                    <Icon name="Info" size={20} className="text-primary mt-0.5 flex-shrink-0" />
                    <span>Традиционные фискальные (кассовые) чеки не формируются и не выдаются, так как сервис работает в децентрализованной юрисдикции Web3, а расчеты производятся в цифровых активах, не подлежащих фискализации через банковский эквайринг.</span>
                  </li>
                </ul>
              </div>
            </div>
          </div>

          {/* Section 3 */}
          <div className="mb-8">
            <h3 className="text-2xl font-bold text-foreground mb-4 flex items-center gap-3">
              <span className="w-8 h-8 bg-primary rounded-full flex items-center justify-center text-white text-sm font-bold">3</span>
              СОГЛАСИЕ НА ОБРАБОТКУ ДАННЫХ
            </h3>
            <div className="space-y-4 ml-11">
              <div className="p-4 bg-gray-50 rounded-lg">
                <p className="text-foreground/80">
                  <strong className="text-primary">3.1.</strong> Клиент дает согласие на запись интервью, его транскрибацию и анализ алгоритмами ИИ.
                </p>
              </div>
              <div className="p-4 bg-gray-50 rounded-lg">
                <p className="text-foreground/80">
                  <strong className="text-primary">3.2.</strong> Клиент разрешает создание своей цифровой копии для участия в виртуальных симуляциях отношений с целью выявления совместимости.
                </p>
              </div>
              <div className="p-4 bg-gray-50 rounded-lg">
                <p className="text-foreground/80">
                  <strong className="text-primary">3.3.</strong> Клиент может в любой момент отозвать согласие и потребовать удаления профиля из базы. При этом средства за текущий оплаченный период не возвращаются.
                </p>
              </div>
            </div>
          </div>

          {/* Section 4 */}
          <div className="mb-8">
            <h3 className="text-2xl font-bold text-foreground mb-4 flex items-center gap-3">
              <span className="w-8 h-8 bg-primary rounded-full flex items-center justify-center text-white text-sm font-bold">4</span>
              ГАРАНТИИ И ОТВЕТСТВЕННОСТЬ
            </h3>
            <div className="space-y-4 ml-11">
              <div className="p-4 bg-gray-50 rounded-lg">
                <p className="text-foreground/80">
                  <strong className="text-primary">4.1. Гарантия активности:</strong> При нахождении Психопрофиля в базе более 3-х месяцев (при оплаченной подписке), Исполнитель гарантирует проведение не менее 1000 виртуальных свиданий (симуляций) алгоритмами системы.
                </p>
              </div>
              <div className="p-4 bg-gray-50 rounded-lg">
                <p className="text-foreground/80">
                  <strong className="text-primary">4.2. Отсутствие гарантии брака:</strong> Исполнитель предоставляет высокоточные аналитические данные о совместимости, но не гарантирует возникновение романтических отношений в реальной жизни, так как это зависит от воли сторон.
                </p>
              </div>
              <div className="p-4 bg-gray-50 rounded-lg">
                <p className="text-foreground/80">
                  <strong className="text-primary">4.3. Безлимитный поиск:</strong> Поиск продолжается до тех пор, пока активна подписка. Клиент самостоятельно принимает решение о достаточности найденных вариантов и прекращении поиска.
                </p>
              </div>
            </div>
          </div>

          {/* Section 5 */}
          <div className="mb-8">
            <h3 className="text-2xl font-bold text-foreground mb-4 flex items-center gap-3">
              <span className="w-8 h-8 bg-primary rounded-full flex items-center justify-center text-white text-sm font-bold">5</span>
              ЗАКЛЮЧИТЕЛЬНЫЕ ПОЛОЖЕНИЯ
            </h3>
            <div className="space-y-4 ml-11">
              <div className="p-4 bg-gray-50 rounded-lg">
                <p className="text-foreground/80">
                  <strong className="text-primary">5.1.</strong> Договор вступает в силу с момента транзакции (оплаты) и действует до момента отказа Клиента от подписки.
                </p>
              </div>
              <div className="p-4 bg-gray-50 rounded-lg">
                <p className="text-foreground/80">
                  <strong className="text-primary">5.2.</strong> Исполнитель оставляет за собой право отказать в обслуживании при выявлении недостоверных данных или этических нарушений со стороны Клиента.
                </p>
              </div>
            </div>
          </div>

          {/* Document Footer */}
          <div className="mt-12 pt-8 border-t border-gray-200 text-center">
            <p className="text-sm text-foreground/50">
              Последнее обновление: 24 декабря 2025 г. | Версия 1.0
            </p>
          </div>
        </div>

        {/* Action Buttons */}
        <div className="mt-8 flex flex-col sm:flex-row gap-4 justify-center">
          <Button
            onClick={handleGoBack}
            variant="outline"
            className="flex items-center justify-center gap-2 px-8 py-4 text-lg"
          >
            <Icon name="ArrowLeft" size={20} />
            Вернуться назад
          </Button>
          <Button
            onClick={handleGoToPayment}
            className="flex items-center justify-center gap-2 px-8 py-4 text-lg bg-primary hover:bg-primary/90"
          >
            Перейти к оплате
            <Icon name="ArrowRight" size={20} />
          </Button>
        </div>
      </main>
    </div>
  );
};

export default ContractOfferPage;